import React from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { Home } from './pages/Home'
import { createTheme, ThemeProvider } from '@mui/material'
import { Apps } from './pages/Apps'
import ProtectedRoute from './components/ProtectedRoute'
import { Login } from './pages/Login'
import { NotFound } from './pages/NotFound'
import { CreateUser } from './pages/CreateUser'
import { ManageUsers } from './pages/ManageUsers'
import { EditUser } from './pages/EditUsers'
import { ManageData } from './pages/ManageData'
import { CreateBatch } from './pages/CreateBatch'
import { ManageBatchs } from './pages/ManageBatchs'
import { ManageBatch } from './pages/ManageBatch'
import { ResetPassword } from './pages/ResetPassword'
import { ForgotPassword } from './pages/ForgotPassword'
import { Inventory } from './pages/Inventory'
import { MovementHistory } from './pages/MovementHistory'
import TestHistory from './pages/TestHistory'

function App() {
	return (
		<ThemeProvider theme={theme}>
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<Navigate to="/login" replace />} />
					<Route path="/login" element={<Login />} />
					<Route path="/forgot-password" element={<ForgotPassword />} />
					<Route path="/reset-password" element={<ResetPassword />} />

					<Route
						path="/home"
						element={
							<ProtectedRoute>
								<Home />
							</ProtectedRoute>
						}
					>
						<Route path="" element={<Apps />} />

						<Route path="crear-usuario" element={<CreateUser />} />
						<Route path="editar-usuario" element={<EditUser />} />
						<Route path="administrar-usuarios" element={<ManageUsers />} />
						<Route path="administrar-lotes" element={<ManageBatchs />} />
						<Route path="administrar-lote" element={<ManageBatch />} />

						<Route path="crear-lote" element={<CreateBatch />} />

						<Route path="administrar-datos" element={<ManageData />} />
						<Route path="inventario" element={<Inventory />} />
						<Route path="historial-movimientos" element={<MovementHistory />} />
						<Route path="historial-pruebas" element={<TestHistory />} />

						<Route path="*" element={<NotFound />} />
					</Route>

					<Route path="*" element={<NotFound />} />
				</Routes>
			</BrowserRouter>
		</ThemeProvider>
	)
}

const theme = createTheme({
	typography: {
		fontFamily: ['Source Sans Pro', 'sans-serif'].join(',')
	},

	palette: {
		primary: {
			main: '#177C3B'
		},
		secondary: {
			main: '#FFCC00'
		}
	}
})

export default App
